type PositionKey = "secretary" | "headCoach" | "welfareOfficer" | "dbsVerifier";

const positionsMap: Record<PositionKey, string> = {
  secretary: "Secretary",
  headCoach: "Head Coach",
  welfareOfficer: "Welfare Officer",
  dbsVerifier: "DBS Verifier",
}

// Function to get a formatted position
const getPosition = (position: string): string => {
  return positionsMap[position as PositionKey] || "Member"
}

export default getPosition